import React from "react";
import { Container, Row, Col, Accordion } from "react-bootstrap";
import PropTypes from "prop-types";
import WorkOrderActiveWorkItem from "./WorkOrderActiveWorkItem";
import "./WorkOrderActiveWorkItems.css";
import { completed } from "./States";

function WorkOrderActiveWorkItems({ workOrder }) {
  const openWorkItems = workOrder.workItems
    .filter((workItem) => !completed.includes(workItem.status));

  if (openWorkItems.length === 0) {
    return (
      <Row>
        <Col>No active work items</Col>
      </Row>
    );
  }

  if (openWorkItems.length === 1) {
    return (
      <Row>
        <Col>
          <WorkOrderActiveWorkItem
            mode="single"
            workItem={openWorkItems[0]}
            workOrder={workOrder}
          />
        </Col>
      </Row>
    );
  }

  return (
    <Container className="coreContent mt-1">
      <Row>
        <Col>
          <Accordion>
            {openWorkItems.map((workItem) => (
              <WorkOrderActiveWorkItem
                key={workItem.id}
                mode="multi"
                workItem={workItem}
                workOrder={workOrder}
              />
            ))}
          </Accordion>
        </Col>
      </Row>
    </Container>
  );
}

WorkOrderActiveWorkItems.propTypes = {
  workOrder: PropTypes.shape({
    workItems: PropTypes.arrayOf(
      PropTypes.shape({
        completed: PropTypes.bool,
        name: PropTypes.string,
      })
    ),
  }).isRequired,
};

export default WorkOrderActiveWorkItems;
